<form #newuserprofile="ngForm" (ngSubmit)="createupdateuserprofile()" class="course-form mb-0">

  <!-- Page header (same layout as the other edit pages) -->
  <header class="cf-head">
    <span class="cf-head__icon"><i class="fas fa-user-edit" aria-hidden="true"></i></span>
    <div class="cf-head__text">
      <h1 class="cf-head__title">Edit Profile</h1>
      <p class="cf-head__sub">Your picture, contact details and what others see on your profile</p>
    </div>
    <div class="cf-head__actions">
      <button type="button" (click)="openmodal()" class="btn m-0 up-settings-btn" title="Time zone settings">
        <i class="fas fa-globe-africa" aria-hidden="true"></i> Time zone
      </button>
      <button type="button" class="btn btn--warning m-0" routerLink="/user/userprofile" [queryParams]="{userprofileID: userprofile.id}">Cancel</button>
      <button type="submit" class="btn m-0" [disabled]="newuserprofile.invalid"><i class="fas fa-save" aria-hidden="true"></i> Update profile</button>
    </div>
  </header>

  <!-- Picture -->
  <section class="cf-card">
    <div class="cf-card__split">
      <div>
        <h2 class="cf-card__title">Profile Picture
          <span class="position-relative d-inline-flex align-items-center">
            <button type="button" data-toggle="dropdown" aria-expanded="false" title="Profile picture"
              class="d-flex align-items-center px-2 bg-transparent border-0 text-body"><i class="fa fa-info-circle"></i></button>
            <span class="info-popup dropdown-menu p-2">
              <span class="form-info-p">Shown on your profile, beside your name in the header and in course forums.</span>
            </span>
          </span>
        </h2>
        <p class="cf-card__hint">A clear, square photo works best.</p>
      </div>
      <div class="cf-image up-picture">
        <img #logoimg src="{{userimage}}" alt="Profile picture of {{userprofile.name}}" class="user-img bg-gray-100 rounded-circle object-cover object-center">
        <button (click)="logo.click()" type="button" id="courseHeaderImgLabel" class="btn m-0 mt-2"><i class="fa fa-plus"></i> Change picture</button>
        <input #logo (change)="handleLogoFileChange($event.target.files)" type="file" accept="image/*" name="logo" aria-labelledby="courseHeaderImgLabel" id="courseHeaderImg" class="sr-only">
      </div>
    </div>
  </section>

  <!-- Basic information -->
  <section class="cf-card">
    <h2 class="cf-card__title"><i class="far fa-id-card" aria-hidden="true"></i> Basic Information</h2>
    <div class="cf-grid">
      <div class="fieldset fieldset--lg">
        <label class="legend" for="schoolname">Name</label>
        <input type="text" [(ngModel)]="userprofile.name" #name name="name" masmength="200" required class="text-field" id="schoolname" placeholder="Jane Doe">
        <button type="button" data-toggle="dropdown" aria-expanded="false" title="Name"
          class="position-absolute right-0 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
            class="fa fa-info-circle"></i></button>
        <div class="info-popup dropdown-menu p-2">
          <p class="form-info-p">Your full name, as students and tutors see it across the school.</p>
        </div>
      </div>
      <div class="fieldset fieldset--lg">
        <label class="legend" for="email">Email address</label>
        <input type="email" id="email" name="email" class="text-field" placeholder="jesse@example.com" #email [(ngModel)]="userprofile.email" readonly>
        <button type="button" data-toggle="dropdown" aria-expanded="false" title="Email address"
          class="position-absolute right-0 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
            class="fa fa-info-circle"></i></button>
        <div class="info-popup dropdown-menu p-2">
          <p class="form-info-p">The address you sign in with. It can't be changed here.</p>
        </div>
      </div>
    </div>
    <div class="fieldset fieldset--lg up-phone">
      <label class="legend" for="phoneno">Phone Number</label>
      <div class="up-phone__row">
        <select name="preSelectedCountryCode" class="text-field up-phone__code" id="preSelectedCountryCode" [(ngModel)]="userprofile.countrycode" aria-label="Country code">
          <option *ngFor="let countryCode of countryCodes" [value]="countryCode.Code">{{countryCode.Country}}: {{countryCode.Code}} </option>
        </select>
        <input type="tel" id="phoneno" name="phoneno" class="text-field up-phone__number" #phoneno [(ngModel)]="userprofile.phoneno" [pattern]="getPhoneNumberValidator()" >
      </div>
      <div *ngIf="!patternPassed()" class="text-danger up-phone__error">
        Invalid phone number format.
      </div>
    </div>
  </section>

  <!-- Privacy -->
  <section class="cf-card">
    <h2 class="cf-card__title"><i class="fas fa-user-shield" aria-hidden="true"></i> What others see</h2>
    <div class="up-toggles">
      <label class="up-toggle" for="showEmail">
        <input type="checkbox" [(ngModel)]="userprofile.showEmail" #showEmail name="showEmail" id="showEmail"
          [checked]="userprofile.id==0">
        <span class="up-toggle__switch" aria-hidden="true"></span>
        <span class="up-toggle__text"><b>Show email on profile</b><small>Others can see your email address on your profile page.</small></span>
      </label>
      <label class="up-toggle" for="showPhone">
        <input type="checkbox" [(ngModel)]="userprofile.showPhone" #showPhone name="showPhone" id="showPhone"
          [checked]="userprofile.id==0">
        <span class="up-toggle__switch" aria-hidden="true"></span>
        <span class="up-toggle__text"><b>Show phone number on profile</b><small>Others can see your phone number on your profile page.</small></span>
      </label>
    </div>
  </section>

  <!-- Appearance: applies and saves straight away, separate from "Update profile" -->
  <section class="cf-card">
    <h2 class="cf-card__title"><i class="fas fa-adjust" aria-hidden="true"></i> Appearance</h2>
    <p class="cf-card__hint">Saved to your account, so it follows you to other devices. Changes apply straight away.</p>
    <div class="ap-options" role="radiogroup" aria-label="Colour theme">
      <button type="button" class="ap-option" role="radio" *ngFor="let opt of themeOptions"
              [class.is-selected]="theme.currentChoice === opt.value" [attr.aria-checked]="theme.currentChoice === opt.value"
              (click)="theme.setChoice(opt.value)">
        <span class="ap-preview" [ngClass]="'ap-preview--' + opt.value" aria-hidden="true">
          <span class="ap-preview__bar"></span>
          <span class="ap-preview__card"><i></i><i></i></span>
          <span class="ap-preview__card ap-preview__card--short"><i></i></span>
        </span>
        <span class="ap-option__label">
          <i [ngClass]="opt.icon" aria-hidden="true"></i> {{opt.label}}
          <span class="ap-option__check" *ngIf="theme.currentChoice === opt.value"><i class="fas fa-check" aria-hidden="true"></i></span>
        </span>
        <span class="ap-option__note">{{opt.note}}</span>
      </button>
    </div>
  </section>

  <!-- Online profiles -->
  <section class="cf-card">
    <h2 class="cf-card__title"><i class="fas fa-link" aria-hidden="true"></i> Online Profiles</h2>
    <div class="cf-grid">
      <div class="fieldset fieldset--lg">
        <label class="legend" for="website">Website Url</label>
        <input type="text" [(ngModel)]="userprofile.website" #website name="website" class="text-field" id="website"
          placeholder="http://websiteurl.com">
        <button type="button" data-toggle="dropdown" aria-expanded="false" title="Website"
          class="position-absolute right-0 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
            class="fa fa-info-circle"></i></button>
        <div class="info-popup dropdown-menu p-2">
          <p class="form-info-p">A link shown on your profile. Optional.</p>
        </div>
      </div>
      <div class="fieldset fieldset--lg">
        <label class="legend" for="reqEnroll">Twitter Profile URL</label>
        <input type="text" class="text-field" [(ngModel)]="userprofile.twitter" #twitter name="twitter" id="reqEnroll" />
        <button type="button" data-toggle="dropdown" aria-expanded="false" title="Twitter"
          class="position-absolute right-0 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
            class="fa fa-info-circle"></i></button>
        <div class="info-popup dropdown-menu p-2">
          <p class="form-info-p">Link to your Twitter (X) profile. Optional.</p>
        </div>
      </div>
      <div class="fieldset fieldset--lg">
        <label class="legend" for="facebook">Facebook Account URL</label>
        <input type="text" class="text-field" [(ngModel)]="userprofile.facebook" #facebook name="facebook" id="facebook" />
        <button type="button" data-toggle="dropdown" aria-expanded="false" title="Facebook"
          class="position-absolute right-0 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
            class="fa fa-info-circle"></i></button>
        <div class="info-popup dropdown-menu p-2">
          <p class="form-info-p">Link to your Facebook profile. Optional.</p>
        </div>
      </div>
      <div class="fieldset fieldset--lg">
        <label class="legend" for="linkedin">LinkedIn Profile URL</label>
        <input type="text" class="text-field" [(ngModel)]="userprofile.linkedin" #linkedin name="linkedin" id="linkedin" />
        <button type="button" data-toggle="dropdown" aria-expanded="false" title="LinkedIn"
          class="position-absolute right-0 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
            class="fa fa-info-circle"></i></button>
        <div class="info-popup dropdown-menu p-2">
          <p class="form-info-p">Link to your LinkedIn profile. Optional.</p>
        </div>
      </div>
    </div>
  </section>

  <!-- About me -->
  <section class="cf-card">
    <h2 class="cf-card__title"><i class="far fa-user" aria-hidden="true"></i> About Me</h2>
    <div class="cf-description">
      <div class="fieldset fieldset--note">
        <label class="legend z-1">About Me</label>
        <quill-editor [(ngModel)]="userprofile.safeBio" #safeBio name="safeBio"></quill-editor>
      </div>
      <aside class="cf-tips">
        <h3><i class="far fa-lightbulb" aria-hidden="true"></i> Tips for your bio</h3>
        <ul>
          <li>Say what you teach or study</li>
          <li>Mention your experience</li>
          <li>Keep it to a few lines</li>
        </ul>
      </aside>
    </div>
  </section>

  <div class="cf-footer">
    <span class="cf-footer__hint">
      <i class="fas fa-user-edit" aria-hidden="true"></i>
      <span>
        <strong>Changes appear on your profile as soon as you save.</strong><br>
        Your time zone is under Time zone, at the top.
      </span>
    </span>
    <span class="cf-footer__actions">
      <button type="button" class="btn btn--warning m-0" routerLink="/user/userprofile" [queryParams]="{userprofileID: userprofile.id}">Cancel</button>
      <button type="submit" class="btn m-0" [disabled]="newuserprofile.invalid"><i class="fas fa-save" aria-hidden="true"></i> Update profile</button>
    </span>
  </div>
</form>

<div class="modal fade" #timezoneselectorModal tabindex="-1" role="dialog" aria-labelledby="timezoneselector"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title" id="timezoneselector">Select Timezone</h3>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form #settingsform="ngForm" name="settingsform" id="settingsform" class="text-sm"
        (ngSubmit)="savetimezone()" action="#" method="POST">
        <p class="text-center">Current Time: {{time}}<br>Current Timezone: {{timezonename}}</p>
        <div class="modal-body">
          <ng-moment-timezone-picker required [(ngModel)]="timeZoneInfo" #timeZoneName name="timeZoneName" customPlaceholderText="Select Timezone">
          </ng-moment-timezone-picker>
        </div>
        <div class="modal-footer justify-content-center gap-1.5">
          <button type="submit" class="btn m-0">Save</button>
          <button type="button" class="btn btn--warning m-0" data-dismiss="modal" aria-label="Cancel">Cancel</button>
        </div>
      </form>
    </div>
  </div>
</div>
